import AxiosServiceHandler from "./AxiosServiceHandler";
import {ShapeType} from "../types/shape";
import {ProductImageStacType} from "../types/product";

class GeoCodingService extends AxiosServiceHandler {
  static search(query) {
    return this.getInstance()
      .get(
        `${process.env.REACT_APP_TRAVEL_TIME_SEARCH_API_URL}?query=${query}`, {
          // credentials: "same-origin",
          headers: {
            "Accept-Language": "en-US",
            "Content-Type": "application/json",
            "X-Application-Id": process.env.REACT_APP_TRAVEL_TIME_SEARCH_APPLICATION_ID,
            "X-Api-Key": process.env.REACT_APP_TRAVEL_TIME_SEARCH_API_KEY
          }
        }
      );
  }

  static framing(areaOfInterest: ShapeType, productImage: ProductImageStacType) {
    let aoi: any = null;
    if (areaOfInterest) {
      if (areaOfInterest.layerType === "circle" && areaOfInterest.circle_radius) {
        aoi = {
          type: "Feature",
          properties: {radius: areaOfInterest.circle_radius / 1000},
          geometry: {type: "Point", coordinates: areaOfInterest.circle_center}
        }
      } else {
        aoi = {
          type: "Polygon",
          coordinates: areaOfInterest.layer
        }
      }
    } else {
      aoi = {
        type: "Polygon",
        coordinates: productImage.geometry?.coordinates
      }
    }
    const data: any = {
      area_of_interest: aoi,
      ids_L0: [productImage.id]
    };
    return this.getInstance()
      .post(
        `${process.env.REACT_APP_MAPIT}${process.env.REACT_APP_MAPIT_FRAMING}`, data
      );
  }
}

export default GeoCodingService;
